export const labFeaturesEndpoints = {
  ziikos: 'ziikos',
  zoumas: 'zoumas',
};
